if (!process.env.VUE_APP_IS_WEB) {
  var VotingCategoryDB = require("../database/models/VotingCategory");
}
import settings from "@/database/settings";
import dates from "@/database/dates";
import strings from "@/database/strings";

import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";

export default {
  FETCH(buildingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new VotingCategoryDB()
          .query({ where: { deleted: null, building_id: buildingId } })
          .fetchAll()
          .then(res => {
            VotingCategoryORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .FETCH(buildingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH_WITH_RELATED(buildingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new VotingCategoryDB()
          .query({ where: { deleted: null, building_id: buildingId } })
          .fetchAll({
            withRelated: [
              {
                building_owner_voting_rights: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            VotingCategoryORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .FETCH_WITH_RELATED(buildingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH(agencyId, queryParams) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new VotingCategoryDB()
          .query({ where: { agency_id: agencyId, deleted: null } })
          .query(qb => {
            queryParams.filter.forEach(filter => {
              qb.where(filter.column, "LIKE", "%" + filter.value + "%");
            });
          })
          .orderBy(queryParams.sort.by, queryParams.sort.dir)
          .fetchPage({
            pageSize: settings.itemsPerPage,
            page: queryParams.page,
          })
          .then(res => {
            VotingCategoryORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .QUERY_FETCH(agencyId, queryParams)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH_BY_PAGE(agencyId, queryParams, pagination) {
    console.log(pagination);
    queryParams.page = pagination.page;
    queryParams.pageSize = pagination.pageSize;
    queryParams.itemsPerPage = pagination.pageSize;
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        //  TODO Implement functionality
      });
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .QUERY_FETCH(agencyId, queryParams)
          .then(res => {
            VotingCategoryORM.deleteAll();
            VotingCategoryORM.insertOrUpdate({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH_WITH_CHARGE_GENERAL(agencyId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .FETCH_WITH_CHARGE_GENERAL(agencyId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new VotingCategoryDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            VotingCategoryORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async POST(item) {
    if (item.is_charge_generale == 1) {
      var error = false;
      var errorMessage = null;
      await this.setOtherChargesGeneralesToFalse(item).catch(err => {
        error = true;
        errorMessage = err;
      });
      if (error) return errorMessage;
    }

    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
      itemPost.slug = strings.get_slug(itemPost.name);
      return new Promise((resolve, reject) => {
        new VotingCategoryDB(itemPost)
          .save()
          .then(res => {
            VotingCategoryORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async PUT(item) {
    if (item.is_charge_generale == 1) {
      var error = false;
      var errorMessage = null;
      await this.setOtherChargesGeneralesToFalse(item).catch(err => {
        error = true;
        errorMessage = err;
      });
      if (error) return errorMessage;
    }

    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      itemPut.slug = strings.get_slug(itemPut.name);
      return new Promise((resolve, reject) => {
        new VotingCategoryDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            VotingCategoryORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async DELETE(item) {
    if (item.is_charge_generale == 1) {
      var error = false;
      var errorMessage = null;
      await this.setOtherChargesGeneralesToFalse(item).catch(err => {
        error = true;
        errorMessage = err;
      });
      if (error) return errorMessage;
    }

    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new VotingCategoryDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            VotingCategoryORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async setOtherChargesGeneralesToFalse(votingCategory) {
    if (!process.env.VUE_APP_IS_WEB) {
      var data = [];
      var errors = [];
      var votingCategoriesToUpdate = [];
      await new VotingCategoryDB({
        building_id: votingCategory.building_id,
        is_charge_generale: 1,
        deleted: null,
      })
        .fetch({ require: false })
        .then(res => {
          if (res) votingCategoriesToUpdate.push(res.serialize());
        })
        .catch(err => {
          errors.push(err);
        });

      for (var votingCategoryToUpdate of votingCategoriesToUpdate) {
        await new VotingCategoryDB(votingCategoryToUpdate)
          .save(
            { is_charge_generale: 0 },
            {
              isUpdate: true,
            }
          )
          .then(res => {
            data.push(res.serialize());
          })
          .catch(err => {
            errors.push(err);
          });
      }
      this.setOtherChargesGeneralesToFalseORM(votingCategory);

      return new Promise((resolve, reject) => {
        if (errors.length == 0) {
          resolve({
            status: "success",
            message: "The process completed successfully.",
            data: data,
          });
        } else {
          reject({
            status: "error",
            message: "There were some errors in the process.",
            errors: errors,
          });
        }
      });

      // ???: renounce
      /**
      return new Promise((resolve, reject) => {
        VotingCategoryDB.where(qb => {
          qb.where("building_id", votingCategory.building_id).where("is_charge_generale", 1);
        })
          .save(
            { is_charge_generale: 0 },
            {
              method: "update",
              patch: true,
              require: false,
              isUpdate: true,
            }
          )
          .then(res => {
            this.setOtherChargesGeneralesToFalseORM(votingCategory);
       // console.log(res);
            resolve(res);
          })
          .catch(err => {
        console.log(err);
            reject(err);
          });
      });
      */
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .SET_OTHER_CHARGES_GENERALES_TO_FALSE(votingCategory.building_id)
          .then(res => {
            this.setOtherChargesGeneralesToFalseORM(votingCategory);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  setOtherChargesGeneralesToFalseORM(votingCategory) {
    VotingCategoryORM.update({
      where(item) {
        return (
          item.building_id == votingCategory.building_id &&
          item.id !== votingCategory.id &&
          item.is_charge_generale == 1
        );
      },
      data(item) {
        item.is_charge_generale = 0;
      },
    });
  },
  REGISTER_GET_VOTING_CATEGORIES(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .REGISTER_GET_VOTING_CATEGORIES(meetingId)
          .then(res => {
            VotingCategoryORM.create({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_BY_MEETING(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .GET_BY_MEETING(meetingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  CUSTOM_DELETE(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        VotingCategoryORM.api()
          .CUSTOM_DELETE(id)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
